"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_HERO_IMAGE_DEFAULT_ASPECT = void 0;
exports.EventHeroImage = EventHeroImage;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/EventHeroImage/index.tsx
// イベント詳細などのヒーロー画像。
//
// aspectRatio:
//   '3:2' / '16:9' / '2:1' — 比率を padding-top で固定し object-fit:cover で
//                            敷き詰める (はみ出した分は切り落とされる)。
//   'auto'                 — 幅 100% ・高さは画像の元比率まかせ。バナーのように
//                            横長で端に情報が入っている画像を切らずに出せる。
//
// 読み込み前/失敗時のプレースホルダ背景は background.neutral.default。
// src が空のときは <img src=""> を描かない (ブラウザが壊れた画像アイコン /
// alt を出してしまうため、プレースホルダ面だけを見せる)。'auto' でも
// 高さ 0 にならないよう、src が無いときは既定比率の面を出す。
//
// 色はすべて theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var ASPECT = {
    '3:2': '66.6667%',
    '16:9': '56.25%',
    '2:1': '50%',
};
/** 既定のアスペクト比 (Skeleton 等で padding-top を揃えるため export する) */
exports.EVENT_HERO_IMAGE_DEFAULT_ASPECT = ASPECT['3:2'];
function EventHeroImage(_a) {
    var src = _a.src, alt = _a.alt, _b = _a.aspectRatio, aspectRatio = _b === void 0 ? '3:2' : _b;
    var p = (0, theme_1.useV2Palette)();
    // 高さ可変。画像をそのままの比率で幅いっぱいに敷く (切り取らない)。
    if (aspectRatio === 'auto' && src) {
        return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                width: '100%',
                backgroundColor: p.background.neutral.default,
                flexShrink: 0,
                // img の下に行ボックス分の隙間ができないように
                lineHeight: 0,
            }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", src: src, alt: alt, sx: { width: '100%', height: 'auto', display: 'block' } }) }));
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
            position: 'relative',
            width: '100%',
            paddingTop: aspectRatio === 'auto'
                ? exports.EVENT_HERO_IMAGE_DEFAULT_ASPECT
                : ASPECT[aspectRatio],
            overflow: 'hidden',
            backgroundColor: p.background.neutral.default,
            flexShrink: 0,
        }, children: !!src && ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", src: src, alt: alt, sx: {
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
            } })) }));
}
